import {
  ALU_2K_GLAZY,
  TWO_K_TYPE,
  SLIDY_30,
  SLIDY_36,
} from './glazingWallTypes';

export const GLASS_TYPE_8 = '8';
export const GLASS_TYPE_10 = '10';
export const GLASS_TYPE_12 = '12';
export const GLASS_TYPE_876 = '876';
export const GLASS_TYPE_1076 = '1076';
export const GLASS_TYPE_1276 = '1276';
export const GLASS_TYPE_1676 = '1676';
export const GLASS_TYPE_2076 = '2076';
export const GLASS_TYPE_3276 = '3276';
export const GLASS_TYPE_3876 = '3876';
export const GLASS_TYPE_3876D = '3876D';
export const GLASS_TYPE_3352 = '3352';
export const GLASS_TYPE_3752 = '3752';
export const GLASS_TYPE_4152 = '4152';
export const GLASS_TYPE_4552 = '4552';
export const GLASS_TYPE_3476 = '3476';
export const GLASS_TYPE_5404 = '5404';
export const GLASS_TYPE_3676 = '3676';
export const GLASS_TYPE_5831 = '5831';

// These are also used when getting excel lists
const glassTypes = [
  GLASS_TYPE_8,
  GLASS_TYPE_10,
  GLASS_TYPE_12,
  GLASS_TYPE_876,
  GLASS_TYPE_1076,
  GLASS_TYPE_1276,
  GLASS_TYPE_1676,
  GLASS_TYPE_2076,
  GLASS_TYPE_3276,
  GLASS_TYPE_3876,
  GLASS_TYPE_3876D,
  GLASS_TYPE_3352,
  GLASS_TYPE_3752,
  GLASS_TYPE_4152,
  GLASS_TYPE_4552,
  GLASS_TYPE_3476,
  GLASS_TYPE_5404,
  GLASS_TYPE_3676,
  GLASS_TYPE_5831,
];

export const glassTypesByWallTypes = {
  [ALU_2K_GLAZY]: [
    GLASS_TYPE_3476,
    GLASS_TYPE_3676,
    GLASS_TYPE_4152,
    GLASS_TYPE_4552,
    GLASS_TYPE_3876D,
  ],
  [TWO_K_TYPE]: [...glassTypes, GLASS_TYPE_3876D],
  [SLIDY_30]: [GLASS_TYPE_8, GLASS_TYPE_10, GLASS_TYPE_876, GLASS_TYPE_1076],
  [SLIDY_36]: [
    GLASS_TYPE_8,
    GLASS_TYPE_10,
    GLASS_TYPE_12,
    GLASS_TYPE_876,
    GLASS_TYPE_1076,
    GLASS_TYPE_1276,
  ],
};

export default glassTypes;
